import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@produzionejb/ui';
import { useGrammiNecessari } from '../../../lib/dashboard-widgets-api';
import { XlsxExportButton } from '../../../components/XlsxExportButton';

export function GrammiNecessariWidget() {
  const { t } = useTranslation();
  const q = useGrammiNecessari();
  const items = q.data?.items ?? [];
  const totalGrammi = items.reduce((acc, i) => acc + i.totalGrammiGrezzo, 0);

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between gap-2">
        <CardTitle>{t('dashboard.grammiNecessari.title')}</CardTitle>
        <XlsxExportButton
          path="/api/dashboard/grammi-necessari?format=xlsx"
          fallbackFilename="grammi-necessari.xlsx"
          label="Excel"
        />
      </CardHeader>
      <CardContent>
        {q.data?.degenerated && (
          <p className="mb-2 rounded bg-amber-50 px-2 py-1 text-xs text-amber-800">
            {t('dashboard.grammiNecessari.degeneratedDisclaimer')}
          </p>
        )}
        {q.isLoading && <p className="text-sm text-slate-500">{t('common.loading')}</p>}
        {q.isError && (
          <p className="text-sm text-red-600">{t('dashboard.grammiNecessari.errorLoad')}</p>
        )}
        {!q.isLoading && !q.isError && items.length === 0 && (
          <p className="text-sm text-slate-500">{t('dashboard.grammiNecessari.empty')}</p>
        )}
        {items.length > 0 && (
          <>
            <table className="w-full text-xs">
              <thead className="border-b border-slate-200 bg-slate-50">
                <tr>
                  <th className="px-2 py-1 text-left font-medium text-slate-600">
                    {t('dashboard.grammiNecessari.col.product')}
                  </th>
                  <th className="px-2 py-1 text-right font-medium text-slate-600">
                    {t('dashboard.grammiNecessari.col.detail')}
                  </th>
                  <th className="px-2 py-1 text-right font-medium text-slate-600">
                    {t('dashboard.grammiNecessari.col.total')}
                  </th>
                </tr>
              </thead>
              <tbody>
                {items.map((row) => (
                  <tr key={row.productId} className="border-b border-slate-100 last:border-0">
                    <td className="px-2 py-1 text-slate-700">{row.productName}</td>
                    <td className="px-2 py-1 text-right font-mono text-[10px] text-slate-500">
                      {row.breakdown
                        .map((b) => `${b.mancantiPezzi}x${b.grammatura}g`)
                        .join(' + ')}
                    </td>
                    <td className="px-2 py-1 text-right font-mono font-semibold text-slate-800">
                      {(row.totalGrammiGrezzo / 1000).toFixed(2)} kg
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="border-t-2 border-slate-300 bg-slate-50">
                  <td className="px-2 py-1 font-semibold text-slate-700" colSpan={2}>
                    {t('dashboard.grammiNecessari.totalLabel')}
                  </td>
                  <td className="px-2 py-1 text-right font-mono font-bold text-slate-900">
                    {(totalGrammi / 1000).toFixed(2)} kg
                  </td>
                </tr>
              </tfoot>
            </table>
          </>
        )}
      </CardContent>
    </Card>
  );
}
